import { render, staticRenderFns } from "./TemplateFeaturesEditor.vue?vue&type=template&id=cceb80e0"
import script from "./TemplateFeaturesEditor.vue?vue&type=script&lang=js"
export * from "./TemplateFeaturesEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports